import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {
  cloudBasePath: string;
  currentHostPath: string;
  error = 404;
  constructor(
    private commonUtil: CommonUtil
  ) { }

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this.currentHostPath = environment.currentHostPath;
    const urlParams = window.location.href.split('?');
    if(urlParams.length > 1) this.error = Number(urlParams[1].split('=')[1]);
  }

}
